import { OutputData } from '@editorjs/editorjs/types/data-formats/output-data';

export interface MNRUserMessagesResponse {
  messageID: number;
  creationDate: string;
  readDate: string | null;
  messageName: string;
  subject: string;
  preview: string;
  contentID: number;
}

export interface MNRContentResponse {
  messageID: number | string;
  contentID?: number | string;
  contentData: string;
  contentDataJson?: OutputData;
  dataPlaceholder: string;
}

export type InitialState = {
  messages: MNRUserMessagesResponse[];
  selectedMessage: MNRContentResponse | undefined;
  hasError: boolean;
  showDetails: boolean;
  errorMessage: string;
  isDisabled: boolean;
};

export interface MessageBase {
  createdAt: string;
  lastModifiedAt?: string;
  lastModifiedBy: string;
  status: HeaderStatus;
  version?: number;
}

export interface MessageHeader extends MessageBase {
  contentId: string;
  messageId?: number | string;
  messageType: string;
  messageName: string;
  origin: string;
  portalScope: string;
  subject: string;
  preview: string;
  validFrom: string;
  validTo: string;
}

export type ExtendedMessageHeader = MessageHeader & MessageStats;

export interface MessageContent extends MessageBase {
  contentId?: number | string;
  contentName: string;
  contentData: string;
  contentDataJson: OutputData;
  placeholders: string;
  placeholdersJson?: string[];
}

export interface MessageStats {
  countAll: number;
  countQualified: number;
  countRead: number;
}

export interface InOutMessageContent extends Omit<MessageContent, 'contentData'> {
  contentData: string;
}

export interface Placeholder {
  name: string;
  placeholder: string;
}

export interface DropdownMenuItem {
  label: string;
  canActivate: boolean;
}

export enum HeaderStatus {
  draft = 'draft',
  ready = 'ready',
  published = 'published',
}

export enum MessageType {
  // dynzgr = 'dynzgr',
  // eslint-disable-next-line sonarjs/future-reserved-words
  public = 'public',
  preload = 'preload',
}

export enum MessageIdentifier {
  UPDATE_CONTENT = 'updateMessageContent',
  UPDATE_CONTENT_STATUS = 'updateMessageContentStatus',
  DELETE_CONTENT = 'deleteMessageContent',
  UPDATE_HEADER = 'updateMessageHeader',
  UPDATE_HEADER_STATUS = 'updateMessageHeaderStatus',
  DELETE_HEADER = 'deleteMessageHeader',
  MESSAGE_CONTENT = 'content',
  MESSAGE_POLLING = 'polling',
  HEADER_STATS = 'stats',
}

export interface RowContents {
  key: string;
  value: string;
}

export const PREDEFINED_VARIABLES = ['firstName', 'lastName', 'email'];

export class MNRTrackData {
  event: string;
  eventAction?: string;
  eventName?: string;
  eventType?: string;
  messageName?: string;
  messageID?: string;
}

export const EVENT_MEINE_NACHRICHTEN = 'meine-nachrichten';

export class MNRTrackOpenMenuData extends MNRTrackData {
  constructor() {
    super();
    this.event = EVENT_MEINE_NACHRICHTEN;
    this.eventAction = 'Envelope-Meine Nachrichten-Hauptmenü';
    this.eventName = 'Envelope';
  }
}

export class MNRTrackOpenMessageData extends MNRTrackData {
  constructor(subject: string, messageID: string, messageName: string, firstTimeOpened = false) {
    super();
    this.event = EVENT_MEINE_NACHRICHTEN;
    this.eventAction = 'Open-Meine Nachrichten';
    this.eventName = subject;
    this.eventType = firstTimeOpened.toString();
    this.messageName = messageName;
    this.messageID = messageID;
  }
}

export class MNRTrackOpenClickData extends MNRTrackData {
  constructor(label: string, messageID: string, messageName: string) {
    super();
    this.event = EVENT_MEINE_NACHRICHTEN;
    this.eventAction = 'Button-Meine Nachrichten';
    this.eventName = label;
    this.messageName = messageName;
    this.messageID = messageID;
  }
}
